package one.healthium.login.ui.silentLogin

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.vm.BaseViewModel

class SilentLoginViewModel(
    private val userInteractor: UserInteractor
) : BaseViewModel() {

    private val _state = MutableStateFlow(SilentLoginUiState())
    val state = _state.asStateFlow()

    fun setToken(token: String) {
        launch {
            try {
                val user = userInteractor.silentSignIn(token)
                _state.update { state -> state.copy(user = user) }
            } catch (e: Exception) {
                Logger.e("silent login error", e)
                _state.update { state -> state.copy(error = e) }
            }
        }
    }
}